/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Paywall_Tree_Cta_BtnInputs */

const en_daily_paywall_tree_cta_btn = /** @type {(inputs: Daily_Paywall_Tree_Cta_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TRY 1 WEEK FOR FREE`)
};

const ar_daily_paywall_tree_cta_btn = /** @type {(inputs: Daily_Paywall_Tree_Cta_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جرّب أسبوعًا مجانًا`)
};

const de_daily_paywall_tree_cta_btn = /** @type {(inputs: Daily_Paywall_Tree_Cta_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 WOCHE KOSTENLOS TESTEN`)
};

const es_daily_paywall_tree_cta_btn = /** @type {(inputs: Daily_Paywall_Tree_Cta_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PRUEBA 1 SEMANA GRATIS`)
};

const fr_daily_paywall_tree_cta_btn = /** @type {(inputs: Daily_Paywall_Tree_Cta_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ESSAYEZ 1 SEMAINE GRATUITEMENT`)
};

const it_daily_paywall_tree_cta_btn = /** @type {(inputs: Daily_Paywall_Tree_Cta_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PROVA 1 SETTIMANA GRATIS`)
};

const ja_daily_paywall_tree_cta_btn = /** @type {(inputs: Daily_Paywall_Tree_Cta_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1週間無料で試す`)
};

const ko_daily_paywall_tree_cta_btn = /** @type {(inputs: Daily_Paywall_Tree_Cta_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1주일 무료 체험`)
};

const pt_br_daily_paywall_tree_cta_btn = /** @type {(inputs: Daily_Paywall_Tree_Cta_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EXPERIMENTE 1 SEMANA GRÁTIS`)
};

const ru_daily_paywall_tree_cta_btn = /** @type {(inputs: Daily_Paywall_Tree_Cta_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ПОПРОБУЙТЕ 1 НЕДЕЛЮ БЕСПЛАТНО`)
};

const th_daily_paywall_tree_cta_btn = /** @type {(inputs: Daily_Paywall_Tree_Cta_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทดลองใช้ฟรี 1 สัปดาห์`)
};

const tr_daily_paywall_tree_cta_btn = /** @type {(inputs: Daily_Paywall_Tree_Cta_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 HAFTA ÜCRETSİZ DENE`)
};

const zh_cn_daily_paywall_tree_cta_btn = /** @type {(inputs: Daily_Paywall_Tree_Cta_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费体验 1 周`)
};

const zh_tw_daily_paywall_tree_cta_btn = /** @type {(inputs: Daily_Paywall_Tree_Cta_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免費體驗 1 週`)
};

/**
* | output |
* | --- |
* | "TRY 1 WEEK FOR FREE" |
*
* @param {Daily_Paywall_Tree_Cta_BtnInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_paywall_tree_cta_btn = /** @type {((inputs?: Daily_Paywall_Tree_Cta_BtnInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Paywall_Tree_Cta_BtnInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_paywall_tree_cta_btn(inputs)
	if (locale === "ar") return ar_daily_paywall_tree_cta_btn(inputs)
	if (locale === "de") return de_daily_paywall_tree_cta_btn(inputs)
	if (locale === "es") return es_daily_paywall_tree_cta_btn(inputs)
	if (locale === "fr") return fr_daily_paywall_tree_cta_btn(inputs)
	if (locale === "it") return it_daily_paywall_tree_cta_btn(inputs)
	if (locale === "ja") return ja_daily_paywall_tree_cta_btn(inputs)
	if (locale === "ko") return ko_daily_paywall_tree_cta_btn(inputs)
	if (locale === "pt_br") return pt_br_daily_paywall_tree_cta_btn(inputs)
	if (locale === "ru") return ru_daily_paywall_tree_cta_btn(inputs)
	if (locale === "th") return th_daily_paywall_tree_cta_btn(inputs)
	if (locale === "tr") return tr_daily_paywall_tree_cta_btn(inputs)
	if (locale === "zh_cn") return zh_cn_daily_paywall_tree_cta_btn(inputs)
	return zh_tw_daily_paywall_tree_cta_btn(inputs)
});